export default {
  'benchmark_less_selected_metrics': 'Please select at least three Metrics',
  'benchmark_add_games_to_compare': 'Select Competitors',
  'benchamrk_add': 'Add',
  'benchamrk_add_search_any_game': 'Search',
  'benchmark_selected': 'Selected',
  'benchmark_clear_all': 'Clear All',
  'benchmark_comparison': 'Comparison',
  'benchmark_you_can_choose_up_to_9_games': 'Up to {num} games can be selected for comparison',
  'benchmark_compare_to_filter_name': 'Compare to',
  'benchmark_compare_to_filter_genre_button': 'Genre',
  'benchmark_table_txchange_position': 'Exchange position',
  'benchmark_table_remove_this_game': 'Remove this game',
  'benchmark_table_add_sort_games': 'Add & Sort Games',
  'benchmark_table_competitors': 'Competitors',
  'benchmark_table_high_risk': 'High risk',
  'benchmark_table_medium_risk': 'Medium risk',
  'benchmark_table_low_risk': 'Low risk',
  'benchmark_table_benchmark': 'Benchmark：',
};
